module.exports = __webpack_public_path__ + "img/ideation.a1f333ec.png";